import './PDFSample.less';

import {
  Button,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
} from '@tonic-one/react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { isInUIC } from '../../../utils/common';
import { IS_UAE } from '@Utils/const';

function PDFSample(props: {
  visible: boolean;
  onClose: () => void;
  templateId: string;
}) {
  const { t } = useTranslation('reportCommon');

  const platform = isInUIC() ? '-v1ecs' : IS_UAE ? '-uae' : '';

  // switch (props.templateId) {
  //   case 'overall threat detections':

  return (
    <Modal
      className="PDFSampleModal"
      ensureFocus={true}
      autoFocus={false}
      closeOnEsc={true}
      closeOnOutsideClick={true}
      isClosable={true}
      isOpen={props.visible}
      onClose={props.onClose}
      size="md"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader />
        <ModalBody>
          <Stack className="PDFContainer">
            {/* 0 */}
            <Image
              src={
                new URL(
                  `./overallThreatDetections/0${platform}.svg`,
                  import.meta.url
                ).href
              }
              key={`${props.templateId}_${0}`}
              className="PDFItem"
            />
            {/* 1 - 15 */}
            {new Array(15).fill(0).map((_, i) => (
              <Image
                src={
                  new URL(
                    `./overallThreatDetections/${i + 1}.svg`,
                    import.meta.url
                  ).href
                }
                key={`${props.templateId}_${i + 1}`}
                className="PDFItem"
              />
            ))}
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Button onClick={props.onClose} minWidth="20x">
            {t('reportCommon.buttons.close')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default memo(PDFSample);
